import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea';
import { AiOutlineCloseSquare } from 'react-icons/ai';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { Link } from 'react-router-dom';
import { FaFileImage, FaFilePdf } from 'react-icons/fa';
import { RiDeleteBin6Line } from 'react-icons/ri';

const Assignment = ({ setLoading, userData }) => {
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [myContent, setMyContent] = useState([]);
    const [selectedContent, setSelectedContent] = useState('');
    const [showDelete, setShowDelete] = useState(false);
const [searchTerm, setSearchTerm] = useState('');
const [filterDate, setFilterDate] = useState('');



    const fetchContent = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-uploaded-content');
            if (response.ok) {
                let data = await response.json();
                                if(userData.role == 'Teacher'){
                    data = data.filter(item => item.added_by == userData.user_id);
                }
                const filteredData = data.filter(item => item.c_type === 'Assignment');
                setMyContent(filteredData);
            } else {
                console.error('Failed to fetch content');
            }
        } catch (error) {
            console.error('Error fetching content:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchContent();
    }, []);


    const handleShowDelete = (uc) => {
    setSelectedContent(uc);
    setShowDelete(true);
  }


                const handleDelete = async (rId, rMedia) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-content/${rId}?media=${encodeURIComponent(rMedia)}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setMyContent((prevData) => prevData.filter((product) => product.id !== rId));
        setShowDelete(false);
        setResponse2({ message: 'Assignment Removed successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting content:', error);
    }
  };


const filteredContent = myContent.filter((uc) => {
    const term = searchTerm.toLowerCase();
    const dateMatch = filterDate ? uc.date === filterDate : true;

    const isUserMatch = uc.user_name.toLowerCase().includes(term);
    const isClassMatch = uc.class_name.toLowerCase().includes(term);
    const isAdminMatch = uc.role === 'SupAdmin' && term.includes('admin');

    return (isUserMatch || isClassMatch || isAdminMatch) && dateMatch;
});



    return (
        <>
        <section className='py-4'>
            <div className='px-4'>
                <HeadingArea message1="Study Material" message2="Assignments" />

                                {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


                        <div className='profile-card'>

                            <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                                <span className="profile-heading align-content-center">Assignment List</span>

                  <div className='profile-input-area ms-auto col-lg-5 border-0 d-md-flex d-block'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search By Class, Teacher'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>

<div className='d-flex'>
 <input
            type='date'
            className='profile-input bg-light rounded-0'
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
        />

         {filterDate && (
    <span
      onClick={() => setFilterDate('')}
className='align-content-center px-2 cursor-pointer bg-light text-danger'
      aria-label="Clear filter"
      title="Clear Filter"
    >
      <AiOutlineCloseSquare size={21} />
    </span>
  )}
  </div>

</div>
  </div>
                            <div className='table-responsive'>
                                <table className='w-100'>

                                    <thead className='account-thead'>
                                        <th className='rounded-start-4'>S No</th>
                                        <th>Content Title</th>
                                        <th>Type</th>
                                        <th>Date</th>
                                        <th>Added By</th>
                                        <th>Class(Section)</th>
                                        <th>Source</th>
                                        <th>Media</th>
                                        <th className='rounded-end-4'>Activity</th>
                                    </thead>


                                    {filteredContent.map((uc, index) => (
                                        <tr className='account-tr'>
                                            <td>{index + 1}</td>
                                            <td>{uc.title}</td>
                                            <td>{uc.c_type}</td>
                                            <td>{uc.date}</td>
                                            <td>
                                                {uc.role === 'SupAdmin'
                                                    ? 'Admin'
                                                    : `${uc.user_name}(${uc.designation})`}
                                            </td>
                                            <td>{uc.class_name}({uc.section})</td>
                                            <td>{uc.source ? <Link to={uc.source} target='_blank'>Click Here</Link> : '--'}</td>
                                            <td>
                                                {uc.media ? (() => {
                                                    // Extract file extension
                                                    const ext = uc.media.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${uc.media}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                                            <td><RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(uc)} /></td>                                  
                                             </tr>
                                    ))}


                                </table>
                            </div>

                        </div>


            </div>
        </section>


      {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Assignment!</p>

<div className='table-responsive'>
<table className='w-100'>

                                    <thead className='account-thead'>
                                        <th className='rounded-start-4'>Content Title</th>
                                        <th>Type</th>
                                        <th>Date</th>
                                        <th>Added By</th>
                                        <th>Class(Section)</th>
                                        <th>Source</th>
                                        <th className='rounded-end-4'>Media</th>
                                    </thead>

<tr className='account-tr'>
                                            <td>{selectedContent.title}</td>
                                            <td>{selectedContent.c_type}</td>
                                            <td>{selectedContent.date}</td>
                                            <td>
                                                {selectedContent.role === 'SupAdmin'
                                                    ? 'Admin'
                                                    : `${selectedContent.user_name}(${selectedContent.designation})`}
                                            </td>
                                            <td>{selectedContent.class_name}({selectedContent.section})</td>
                                            <td>{selectedContent.source ? <Link to={selectedContent.source} target='_blank'>Click Here</Link> : '--'}</td>
                                            <td>
                                                {selectedContent.media ? (() => {
                                                    // Extract file extension
                                                    const ext = selectedContent.media.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${selectedContent.media}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Uploaded Assignment will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedContent.id, selectedContent.media)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

        </>
    )
}

export default Assignment